<template>
  <v-dialog value="true" persistent fullscreen hide-overlay>
    <v-card tile color="#fff">
      <cabecalho-pagina 
          :ehALei14_133="ehALei14_133"
          eh-tela-resultado
          :ehCompraPropostaManualEhAtiva="ehCompraPropostaManualEhAtiva"
          @abrirChatNoTabItensLotes="processarEventoAbrirChatNoTabItensLotes"/>

      <v-container color="#fff" class="resultado">
        <v-card-text class="az-tabs">
          <v-tabs left class="resultado__aba">
            <p class="resultado__aba-titulo">Resultado</p>
            <div class="ajuste-margem">
              <v-tab v-for="aba in abasValidas"
                     :key="aba.ordem"
                     :to="construirRota(aba.rota)"
                     exact
                     exact-active-class="active"
                     class="resultado__aba-item">
                {{aba.titulo}}
              </v-tab>
            </div>
          </v-tabs>

          <transition name="fade" mode="out-in">
            <router-view/>
          </transition>
        </v-card-text>
      </v-container>
    </v-card>
      <chat-sheet :resultados="resultados"
                  :ehPerfilComprador="false"
                  @enviarMensagem="processarEventoEnviarMensagem"
                  @tabClicked="processarEventoTabCliked"
                  @itemLoteClicked="processarEventoItemLoteClicked"
                  @fecharChat="processarEventoFecharChat"></chat-sheet>
  </v-dialog>
</template>

<script>
import SmartTimerMixin from '@/core/mixins/SmartTimerMixin'
import {mapState} from 'vuex'
import {actionTypes, mutationTypes} from '@/core/constants'
import CabecalhoPagina from '@/views/pages/fornecedor/commons/cabecalho-pagina/CabecalhoPagina'
import ChatSheet from '@/views/pages/commons/chat-compra-direta/chat-area/ChatSheet'

export default {
    name: 'Resultado',
    mixins: [SmartTimerMixin],
    components: {
        ChatSheet,
        CabecalhoPagina
    },
    data() {
        return {
            compraDiretaId: null,
            propostaId: null,
            abas: [
                {
                    titulo: 'Documentos/Proposta',
                    rota: 'DocumentoPropostaDoFornecedor',
                    ordem: 1
                },
                {
                    titulo: 'Resultado',
                    rota: 'ResultadoFinalDoFornecedor',
                    ordem: 2
                }
            ],
            websocketSubscriptionForUserStatus: null,
            websocketSubscriptionForMessage: null,
        }
    },
    computed: {
        ...mapState(['fornecedor', 'resumoProposta', 'compraDireta', 'chat', 'websocketService', 'loki', 'parametros']),
        abasValidas() {
            return this.abas.filter(aba => {
                return !(aba.titulo === 'Documentos/Proposta'
                    && !this.fornecedor.possuiLoteItemVencedor)
            })
        },
        ehALei14_133(){
            return this.ehLei14_133(this.compraDireta.amparoLegal)
        },
        resultados(){
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            return this.fornecedor.resultadoTodosLotesEItens.sort((item1, item2) => {
                if(item1.loteItem === item2.loteItem) return 0
                if(item1.loteItem < item2.loteItem) return -1
                return 1
            })
        },
        detalhesCompra(){
            return this.chat.conversacao.compra
        },
        destinatarioConversacao(){
            return this.chat.conversacao.destinatario
        },
        itemLoteAtualChat(){
            return this.chat.conversacao.itemOuLoteAtualDoChat
        },
        ehCompraPropostaManualEhAtiva() {
            return this.propostaManualAtiva && this.amparoLegalEhLei14133Art75VIII
        },
        propostaManualAtiva() {
            return Boolean(this.parametros.propriedadesCompraDiretas.propostaManual)
        },
        amparoLegalEhLei14133Art75VIII() {
            const lei = this.compraDireta?.amparoLegal?.lei || ''
            return typeof lei === 'string' && lei.includes('Lei 14.133/2021, Art. 75, VIII')
        },
    },
    async beforeRouteUpdate(to, from, next) {
        try {
            this.setCompraDiretaIdEPropostaId()
            await this.buscarResumoProposta()
            await this.verificarSeFornecedorPossuiLoteItemVencedor()
            next()
        } catch (e) {
            if (e.message.includes('is undefined')) {
                this.mostrarNotificacaoErroDefaultEReload()
            } else {
                this.mostrarNotificacaoErro(e.message)
            }
        }
    },
    async created() {
        try {
            this.setCompraDiretaIdEPropostaId()
            await this.buscarResumoProposta()
            await this.verificarSeFornecedorPossuiLoteItemVencedor()
            await this.buscarCompraDireta()
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
    },
    async mounted(){
        await this.buscarResultadoTodosLotesEItens()
        await this.contarTotalMensagensNaoLidasCentral()
        await this.abrirChatMensagens()
        this.$root.$on('notificacaoMensagemClicked', async () => await this.abrirChatMensagens())

        const subscribeWebsocketInterval = setInterval(() => {
            if(this.websocketService){
                this.subcribeForUserCompradorOnlineStatus()
                clearInterval(subscribeWebsocketInterval)
            }
        }, 60000)

        this.createSmartTimer('atualizarInformacoesDisputa', 'atualizarInformacoesDisputa', 10000, {
            autostart: true,
            immediate: true
        })
        this.createSmartTimer('consultarCompradorOnlineACada2Minutos', 'consultarCompradorOnlineACada2Minutos', 120000, {
            autostart: true,
            immediate: true
        })
    },
    beforeDestroy() {
        this.unsubcribeForChatMessage()
        this.$store.commit(mutationTypes.SET_DEVE_ABRIR_CHAT, false)
        this.$store.commit(mutationTypes.SET_CHAT_CONVERSACAO_ESTADO_INICIAL)
    },
    methods: {
        async buscarResumoProposta() {
            const infoObj = {
                compraDiretaId: this.compraDiretaId,
                propostaId: this.propostaId
            }
            await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_RESUMO_DA_COMPRA_DIRETA_NA_PROPOSTA, infoObj)
        },
        async verificarSeFornecedorPossuiLoteItemVencedor() {
            await this.$store.dispatch(actionTypes.FORNECEDOR.VERIFICAR_SE_POSSUI_LOTE_ITEM_VENCEDOR,
                this.compraDiretaId)
        },
        async buscarCompraDireta() {
            await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_DETALHES_DA_COMPRA_DIRETA, this.compraDiretaId)
        },
        construirRota(name) {
            return {
                name,
                params: {
                    id: this.compraDiretaId,
                    propostaId: this.propostaId
                },
                query: this.$route.query
            }
        },
        async atualizarInformacoesDisputa() {
            if (this.resumoProposta && this.resumoProposta.situacao === 'EM_ANALISE') {
                await this.buscarResumoProposta()
                await this.verificarSeFornecedorPossuiLoteItemVencedor()
                await this.buscarResultadoTodosLotesEItens()
            }
            const redirecionarParaResultadoFinal = !this.$store.state.fornecedor.possuiLoteItemVencedor
            this.redirecionarFornecedorNaoGanhador(redirecionarParaResultadoFinal)
        },
        redirecionarFornecedorNaoGanhador(redirecionarParaResultadoFinal) {
            if(redirecionarParaResultadoFinal) {
                this.$router.push({
                    name: 'ResultadoFinalDoFornecedor',
                    params: {
                        id: this.compraDiretaId,
                        propostaId: this.propostaId
                    }
                })
            }
        },
        setCompraDiretaIdEPropostaId() {
            this.compraDiretaId = this.$route.params.id
            this.propostaId = this.$route.params.propostaId
        },

        /**
         * TODO chat
         */
        async buscarResultadoTodosLotesEItens() {
            await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_RESULTADO_DE_TODOS_LOTES_E_ITENS, this.compraDiretaId)

            if(this.itemLoteAtualChat.id){
                const itemLote = this.resultados.find(r => r.id === this.itemLoteAtualChat.id)
                this.$store.commit(mutationTypes.SET_ITEM_OU_LOTE_ATUAL_DO_CHAT, itemLote)
            }
        },
        async contarTotalMensagensNaoLidasCentral() {
            await this.$store.dispatch(actionTypes.CONTAR_MENSAGENS_PARA_CENTRAL_CHAT, {
                compraDiretaId: this.compraDiretaId,
                ehComprador: false
            })
        },
        async processarEventoAbrirChatNoTabItensLotes() {
            await this.contarTotalMensagensNaoLidasCentral()

            const { data } = await this.$store.dispatch(actionTypes.CONTAR_MENSAGENS_NAO_LIDAS_ITENS_LOTES, {
                compraDiretaId: this.compraDiretaId,
                ehComprador: false
            })

            data.itens.forEach(item => {
                this.fornecedor.resultadoTodosLotesEItens
                    .find(r => r.tipo === item.tipo && r.id === item.id)
                    .totalMensagensNaoLidas = item.totalNaoLidas
            })

            this.$store.commit(mutationTypes.SET_DEVE_ABRIR_CHAT, true)
            this.$store.commit(mutationTypes.SET_CURRENT_TAB_CHAT, 'tab-itens-lotes')
        },
        async processarEventoItemLoteClicked(itemOuLote) {
            if(!this.websocketService)
                throw new Error('A conexão websocket foi encerrada, atualize a página.')

            const destinatario = {
                id: this.compraDireta.comprador.id,
                nome: this.compraDireta.comprador.nome,
                iniciais: this.getInicias(this.compraDireta.comprador.nome),

            }
            const detalhes = {
                compraDiretaId: this.compraDireta.id,
                processo: this.compraDireta.processo,
                itemOuLoteDescricao: itemOuLote.loteItem,
                itemCompraDiretaId: ('ITEM' === itemOuLote.tipo) ? itemOuLote.id : null,
                loteCompraDiretaId: ('LOTE' === itemOuLote.tipo) ? itemOuLote.id : null,
                tipo: itemOuLote.tipo,
            }

            this.$store.commit(mutationTypes.SET_CHAT_CONVERSACAO_MENSAGENS)
            this.$store.commit(mutationTypes.SET_CHAT_CONVERSACAO_DETALHES_COMPRA, detalhes)
            this.$store.commit(mutationTypes.SET_CHAT_CONVERSACAO_DESTINATARIO, destinatario)
            await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_CONVERSACAO_CHAT_MENSAGENS)
            this.$store.commit(mutationTypes.SET_ITEM_OU_LOTE_ATUAL_DO_CHAT, itemOuLote)
            this.$store.commit(mutationTypes.SET_CURRENT_TAB_CHAT, 'tab-mensagens')
            this.subscribeForChatMessage()
            this.atualizarStatusChatDestinatario()

            if(itemOuLote.ranking && itemOuLote.ranking.length > 0){
                const fornecedor = itemOuLote.ranking.find(r => r.situacaoFornecedor === 'EM_ANALISE')
                if(fornecedor && (fornecedor.pessoaId === this.loki.user.domainId))
                    await this.marcarMensagensComoLidas(itemOuLote)
            }

        },
        processarEventoFecharChat(){
            this.$store.commit(mutationTypes.SET_DEVE_ABRIR_CHAT, false)
            this.unsubcribeForChatMessage()
        },
        processarEventoTabCliked(tab){
            if(tab === 'tab-itens-lotes') {
                this.unsubcribeForChatMessage()
                this.processarEventoAbrirChatNoTabItensLotes()
            }else if(!this.websocketSubscriptionForMessage)
                this.subscribeForChatMessage()
            this.$store.commit(mutationTypes.SET_CURRENT_TAB_CHAT, tab)
        },
        subscribeForChatMessage(){
            const itemOuLoteId = this.getItemOuLoteId()
            const topicChat = `/topic/compraDiretaId=${this.compraDiretaId}&itemOuLote=${itemOuLoteId}`

            this.websocketSubscriptionForMessage = this.websocketService.subscribe(topicChat, (message) => {
                const body = JSON.parse(message.body)
                body.ehMensagemMinha = (body.remetente.id === this.loki.user.domainId && body.remetente.tipo === this.loki.user.domainType)
                this.$store.commit(mutationTypes.SET_CHAT_CONVERSACAO_MENSAGENS, [body])
                this.contarTotalMensagensNaoLidasCentral()
            })

            this.atualizarStatusChatDestinatario()
        },
        unsubcribeForChatMessage(){
            if(this.websocketSubscriptionForMessage) {
                this.websocketService.unsubscribe(this.websocketSubscriptionForMessage.id)
                this.websocketSubscriptionForMessage = null
            }
        },
        getInicias(razaoSocial){
            const parts = razaoSocial.split(' ')
            if(parts.length > 1)
                return `${parts[0].charAt(0)}${parts[1].charAt(0)}`.toUpperCase()
            return parts[0].substring(0, 2).toUpperCase()
        },
        getItemOuLoteId(){
            if(this.detalhesCompra.tipo === 'ITEM')
                return this.detalhesCompra.itemCompraDiretaId
            return this.detalhesCompra.loteCompraDiretaId
        },
        atualizarStatusChatDestinatario() {
            const usuario = this.chat.usuariosOnline.find(usuario => usuario.dominioId === this.destinatarioConversacao.id)

            if (usuario)
                this.$store.commit(mutationTypes.SET_CHAT_CONVERSACAO_DESTINATARIO, {
                    ...this.destinatarioConversacao,
                    online: usuario.online
                })
            else
                this.$store.commit(mutationTypes.SET_CHAT_CONVERSACAO_DESTINATARIO, {
                    ...this.destinatarioConversacao,
                    online: false
                })
        },
        async marcarMensagensComoLidas(itemOuLote){
            const { data } = await this.$store.dispatch(actionTypes.MARCAR_MENSAGENS_LIDAS_ITENS_LOTES, {
                tipo: itemOuLote.tipo,
                ehComprador: false
            })

            this.resultados.find(r => r.id === data.id && r.tipo === data.tipo).totalMensagensNaoLidas = 0
        },
        async abrirChatMensagens(){
            if(this.chat.deveAbrirChat) {
                this.subscribeForChatMessage()
                this.atualizarStatusChatDestinatario()

                const {tipo, itemCompraDiretaId, loteCompraDiretaId} = this.detalhesCompra

                const itemOuLoteAtual = this.resultados.find(r => this.predicateItemLoteAtualDoChat(r, tipo, (itemCompraDiretaId || loteCompraDiretaId)))

                if(itemOuLoteAtual)
                    this.$store.commit(mutationTypes.SET_ITEM_OU_LOTE_ATUAL_DO_CHAT, itemOuLoteAtual)
            }
        },
        predicateItemLoteAtualDoChat(resultado, tipo, itemOuLoteId){
            return resultado.tipo === tipo && resultado.id === itemOuLoteId
        },

        /**
         * TODO subscribe for user comprador status
         */
        subcribeForUserCompradorOnlineStatus(){
            this.websocketService.subscribe('/topic/CONSULTAR:ESTRUTURA_ORGANIZACIONAL:ONLINE', (message) => {
                this.$store.commit(mutationTypes.SET_USUARIOS_ONLINE_COMPRA_DIRETA, JSON.parse(message.body))
            })
            this.consultarCompradorOnline()

            this.websocketService.subscribe('/topic/FORNECEDOR:ONLINE', (message) => {

                const dados = {
                    tipo: this.loki.user.domainType,
                    usuarioId: this.loki.user.id,
                    dominioId: this.loki.user.domainId,
                    online: true
                }

                this.websocketService.send('/topic/CONSULTAR:FORNECEDOR:ONLINE', JSON.stringify(dados))
            })
        },

        consultarCompradorOnline(){
            if(this.websocketService)
                this.websocketService.send('/topic/ESTRUTURA_ORGANIZACIONAL:ONLINE', {})
        },

        /**
         * TODO Enviar mensagem
         */
        processarEventoEnviarMensagem(mensagem){
            const itemOuLoteId = this.getItemOuLoteId()
            const dados = {
                compraDiretaId: this.compraDiretaId,
                itemOuLoteId: itemOuLoteId,
                tipo: this.detalhesCompra.tipo,
                mensagem: mensagem,
                fornecedorId: this.loki.user.domainId,
                uoId: this.destinatarioConversacao.id,
                usuarioId: this.loki.user.id
            }
            const headers = {
                origemComprador: false
            }

            this.websocketService.send(`/chat/chat-privado/${this.compraDiretaId}/${itemOuLoteId}`, JSON.stringify(dados), headers)
            this.marcarMensagensComoLidas({tipo: this.detalhesCompra.tipo})
            this.contarTotalMensagensNaoLidasCentral()
        },

        consultarCompradorOnlineACada2Minutos(){
            this.consultarCompradorOnline()
        }
    },
    watch: {
        'chat.usuariosOnline': {
            handler(val) {
                if (val) this.atualizarStatusChatDestinatario()
            },
            immediate: true,
            deep: true
        },
    }
}
</script>

<style scoped lang="stylus">
.resultado
  overflow-y auto
  padding-top 64px
  background-color #fff

  .az-tabs
    margin 20px 0
    padding 0

  &__aba
    &-titulo
      margin 0
      padding 0
      text-transform uppercase
      color #777
      font-size 18px

    &-item .v-tabs__item
      border-right 1px solid #fff
      border-left 1px solid #fff
      border-top 1px solid #fff
      border-bottom 1px solid #ccc

    &-item .active
      border-right 1px solid #ccc
      border-top 1px solid #ccc
      border-left 1px solid #ccc
      border-bottom 1px solid #fff

    .ajuste-margem
      margin-bottom -1px

@media (max-width 1220px)
  .resultado .az-tabs
    margin 0
    padding 20px

@media only screen and (min-width 960px)
  .resultado.container
    max-width 1200px

@media (max-width 960px)
  .resultado
    padding-top 48px

    &__aba-titulo
      display none

    &__aba .v-tabs__container
      justify-content center

@media (max-width 500px)
  .resultado .az-tabs
    padding 20px 10px
</style>